<script lang="ts" setup>
	const props = defineProps<{
		cardDetails: DebitCardPayload | null
	}>()
	const { User } = reactor(useUser())

	const cardIcon = computed(() => {
		const type = ref({
			iconDir: 'debit-card-icons',
			name: ''
		})
		switch (props.cardDetails?.type?.trim()) {
			case 'mastercard':
				type.value.name = 'mastercard'
				break
			case 'verve':
				type.value.name = 'verve-card'
				break
			case 'visa':
				type.value.name = 'visa-card'
				break
			default:
				break
		}
		return type
	})
</script>

<template>
	<div
		class="pointer-events-none relative flex flex-col items-start overflow-hidden rounded-md lg:rounded-none lg:rounded-t-md"
	>
		<div class="flex w-full items-end justify-between gap-10 bg-[#F4F3FF99] px-5 py-4">
			<div class="pointer-events-none text-lg font-medium leading-snug text-gray-600">
				**** **** **** **** {{ cardDetails?.last_four || '' }}
			</div>

			<lazy-tools-icon :dir="cardIcon.value.iconDir" :icon="cardIcon.value.name" />
		</div>

		<div class="inline-flex min-h-[98px] w-full flex-col bg-purple-500 px-5 text-[15.44px]">
			<div class="space-y-2 pt-5">
				<div class="text-[10px] font-medium uppercase leading-snug text-white">
					{{ cardDetails?.bank_name || 'Account name' }}
				</div>
				<div class="text-sm font-medium capitalize leading-snug text-white">
					{{ cardDetails?.account_name || `${User?.first_name || ''} ${User?.last_name || '---'}` }}
				</div>
			</div>
		</div>
	</div>
</template>
